import React, { memo } from "react";
import AerosNode from "./AerosNode";
import { i18n } from "../../../translate/i18n";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="interval" selected={selected} isConnectable={isConnectable}>
    {i18n.t("aeros.flow.summary.interval", { sec: data.sec })}
  </AerosNode>
));
